<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col class="py-0">
        <div v-if="model.id" class="mb-3">
          <label class="body-1">Group Name:</label>
          <label class="body-1 ml-2 black--text">{{ model.name }}</label>
        </div>
        <div v-else>
          <v-text-field
            id="group-form-name-input"
            dense
            required
            outlined
            label="New Group Name"
            v-model="model.name"
            :rules="rules.name"
          />
        </div>
        <div>
          <v-text-field
            id="group-form-description-input"
            dense
            required
            outlined
            label="Group Description"
            v-model="model.description"
            :rules="rules.description"
          />
        </div>
        <div>
          <v-select
            dense
            outlined
            id="group-domain-select"
            label="Select a domain"
            :items="allowedDomains"
            item-value="_id"
            item-text="name"
            v-model="model.domain"
            :rules="rules.domain"
          />
        </div>
        <div>
          <label class="body-1">Permissions</label>
          <anchor-list-select
            id="group-form-permission-select"
            class="mt-2"
            height="260"
            v-model="model.permissions"
            :options="allowedPermissions"
            :loading="loading"
            :error="error"
          />
        </div>
      </v-col>
    </v-row>
    <div class="d-flex mb-4 mt-4">
      <v-spacer />
      <v-btn id="group-form-cancel-btn" @click="() => $emit('cancel')">
        Cancel
      </v-btn>
      <v-btn
        id="group-form-save-btn"
        :disabled="!valid || error"
        :loading="loading"
        color="primary"
        class="ml-3"
        @click="submit"
      >
        Save
      </v-btn>
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import GROUP_MODEL from './resources/model';
import GROUP_RULES from './resources/rules';

export default {
  name: 'AdminGroupsForm',
  data: () => ({
    valid: false,
    model: {},
    rules: GROUP_RULES,
    permissions: [],
    loading: true,
    error: null,
  }),
  computed: {
    allowedDomains() {
      return this.$store.getters.role?.domains || [];
    },
    allowedPermissions() {
      if (this.model.domain) {
        const permissions = this.permissions.filter(p => p.domain === this.model.domain).map(p => p.name);
        return permissions;
      }
      return [];
    },
    selectedDomain() {
      return this.model.domain;
    },
  },
  methods: {
    setModel(group) {
      this.$refs.form.reset();
      if (group) {
        const mdl = {};
        Object.keys(GROUP_MODEL).forEach(key => {
          mdl[key] = group[key];
        });
        mdl.id = group._id;
        this.model = mdl;
      } else {
        this.model = this.$utils.deepCopy(GROUP_MODEL);
      }
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      const method = this.model.id ? 'put' : 'post';
      const url = this.model.id ? `/v1/groups/${this.model.id}` : '/v1/groups';
      const data = this.$utils.deepCopy(this.model);
      delete data.id;

      this.$requests[method](url, data)
        .then(() => {
          this.$toast.success('Group successfully saved!', { timeout: 3000 });
          this.$emit('success');
        })
        .catch(err => {
          this.$toast.error(err.response.data?.message || 'Unable to save group...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
    getPermissions() {
      this.loading = true;
      this.$requests
        .get('/v1/permissions')
        .then(response => {
          const permissions = response.data;
          this.permissions = permissions.sort((a, b) => a.name < b.name);
        })
        .catch(() => {
          this.$toast.error('Could not resolve list of permissions...', { timeout: 3000 });
          this.error = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    selectedDomain(domain, old) {
      if (old && domain !== old) {
        this.model.permissions = [];
      }
    },
  },
  mounted() {
    this.getPermissions();
  },
};
</script>
